// ** Initial State
const initialState = {
  push: [],
  allPush: [],
  tags:[],
  pushNotificationListWithPagination: {
    limit: 30,
    page: 0,
    total_pages: null,
    total_records: null,
    data: null,
  },
  pageLoader: true,
  pushNotificationData:null
}

const pushs = (state = initialState, action) => {
  switch (action.type) { 
     
    case 'SENT_NOTIFICATON':
      return { ...state, push: action.data }
    case 'GET_NOTIFICATION':
      return { ...state, allPush:  action.data }
    case 'GET_NOTIFICATION_VIEW':
      return { ...state, pushNotificationData:  action?.data?.data }
    case 'GET_ALL_TAGS':
      return { ...state, tags: action.data.data }
    case 'DELETE_NOTIFICATION':
      return { ...state, allPush:  action.data }
    case "GET_ALL_PUSH_NOTIFICATION_WITH_PAGINATION":
      return { ...state, pushNotificationListWithPagination: action.data, pageLoader: false};
    case "PAGE_LOADER":
      return { ...state, pageLoader: action.data };
    default:
      return { ...state }
  }
}
export default pushs